/* Vandal — strona O nas. Kazdy element startuje sam, takze po przeladowaniu sekcji w edytorze motywu. */
(function(){
  if(window.VandalOnas)return;
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hoverDevice=window.matchMedia&&matchMedia('(hover:hover)').matches;

  /* ================= HERO: plynny chrom (WebGL) ================= */
  function initHero(wrap,ac){
    var cv=wrap.querySelector('canvas'),fb=wrap.querySelector('img');
    if(!cv||!fb)return;
    var src=wrap.getAttribute('data-tex')||fb.currentSrc||fb.src;
    var gl=null;try{gl=cv.getContext('webgl',{antialias:true})}catch(e){}
    if(!gl){cv.remove();return}
    var vs='attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
    var fs=['precision mediump float;',
      'uniform sampler2D t;uniform vec2 res;uniform vec2 m;uniform float time;uniform float hov;',
      'void main(){',
      ' vec2 px=gl_FragCoord.xy;vec2 c=res*.5;float S=min(res.x,res.y)*.96;',
      ' vec2 iuv=(px-c)/S+.5;iuv.y=1.-iuv.y;',
      ' float d=distance(px,m)/S;',
      ' float rip=sin(d*34.-time*5.)*exp(-d*5.5)*.024*hov;',
      ' vec2 dir=normalize(px-m+.001);',
      ' vec2 off=vec2(dir.x,-dir.y)*rip+vec2(sin(iuv.y*9.+time*.9),cos(iuv.x*8.+time*.7))*.003;',
      ' float ca=.0025+abs(rip)*.7;vec2 q=iuv+off;',
      ' vec3 col=vec3(texture2D(t,q+vec2(ca,0.)).r,texture2D(t,q).g,texture2D(t,q-vec2(ca,0.)).b);',
      ' if(q.x<0.||q.x>1.||q.y<0.||q.y>1.)col=vec3(0.);',
      ' col=max(col-.04,0.)*1.07;float lum=max(col.r,max(col.g,col.b));',
      ' float sw=smoothstep(.05,0.,abs(iuv.x*.7+iuv.y-mod(time*.3,3.4)+.5));',
      ' col+=sw*.5*smoothstep(.12,.4,lum);',
      ' gl_FragColor=vec4(col,1.);}'].join('\n');
    function sh(ty,s){var o=gl.createShader(ty);gl.shaderSource(o,s);gl.compileShader(o);if(!gl.getShaderParameter(o,gl.COMPILE_STATUS))throw new Error(gl.getShaderInfoLog(o));return o}
    var pr;try{pr=gl.createProgram();gl.attachShader(pr,sh(gl.VERTEX_SHADER,vs));gl.attachShader(pr,sh(gl.FRAGMENT_SHADER,fs));gl.linkProgram(pr);gl.useProgram(pr)}catch(e){cv.remove();return}
    var b=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,b);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,1,-1,-1,1,1,1]),gl.STATIC_DRAW);
    var loc=gl.getAttribLocation(pr,'p');gl.enableVertexAttribArray(loc);gl.vertexAttribPointer(loc,2,gl.FLOAT,false,0,0);
    var uR=gl.getUniformLocation(pr,'res'),uM=gl.getUniformLocation(pr,'m'),uT=gl.getUniformLocation(pr,'time'),uH=gl.getUniformLocation(pr,'hov');
    var tex=null,img=new Image();img.crossOrigin='anonymous';
    img.onerror=function(){cv.remove()};
    img.onload=function(){
      if(ac.signal.aborted)return;
      tex=gl.createTexture();gl.bindTexture(gl.TEXTURE_2D,tex);
      ['TEXTURE_WRAP_S','TEXTURE_WRAP_T'].forEach(function(k){gl.texParameteri(gl.TEXTURE_2D,gl[k],gl.CLAMP_TO_EDGE)});
      gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
      try{gl.texImage2D(gl.TEXTURE_2D,0,gl.RGB,gl.RGB,gl.UNSIGNED_BYTE,img)}catch(e){cv.remove();return}
      fb.style.visibility='hidden';go();
    };
    img.src=src;
    var W=1,H=1,dpr=Math.min(2,window.devicePixelRatio||1);
    function size(){var r=wrap.getBoundingClientRect();W=Math.max(1,Math.round(r.width*dpr));H=Math.max(1,Math.round(r.height*dpr));cv.width=W;cv.height=H;gl.viewport(0,0,W,H)}
    size();window.addEventListener('resize',size,{signal:ac.signal});
    var mx=.5,my=.5,tx=.5,ty=.5,h=0,th=0,last=-1e9,vis=true,run=false,t0=performance.now();
    function setP(e){var r=wrap.getBoundingClientRect();tx=(e.clientX-r.left)/r.width;ty=(e.clientY-r.top)/r.height;th=1;last=performance.now()}
    wrap.addEventListener('pointermove',setP,{signal:ac.signal});wrap.addEventListener('pointerdown',setP,{signal:ac.signal});
    wrap.addEventListener('pointerleave',function(){th=0},{signal:ac.signal});
    function frame(now){
      if(ac.signal.aborted){run=false;return}
      var t=(now-t0)/1000;
      if(now-last>2500){th=reduce?0:.5;tx=.5+Math.cos(t*.55)*.16;ty=.5+Math.sin(t*.8)*.12}
      mx+=(tx-mx)*.08;my+=(ty-my)*.08;h+=(th-h)*.05;
      gl.uniform2f(uR,W,H);gl.uniform2f(uM,mx*W,(1-my)*H);gl.uniform1f(uT,reduce?0:t);gl.uniform1f(uH,h);
      gl.drawArrays(gl.TRIANGLE_STRIP,0,4);
      if(vis&&!reduce)requestAnimationFrame(frame);else run=false;
    }
    function go(){if(!run){run=true;requestAnimationFrame(frame)}}
    if('IntersectionObserver' in window){var io=new IntersectionObserver(function(en){vis=en[0].isIntersecting;if(vis&&tex)go()});io.observe(wrap);ac.signal.addEventListener('abort',function(){io.disconnect()})}
  }

  /* ================= KIM JESTESMY: stos zdjec ================= */
  function initPile(pile,ac){
    function next(){
      var figs=pile.querySelectorAll('figure');if(figs.length<2)return;
      var top=figs[figs.length-1];
      pile.insertBefore(top,figs[0]);
      pile.classList.remove('is-fire');void pile.offsetWidth;pile.classList.add('is-fire');
    }
    pile.addEventListener('click',next,{signal:ac.signal});
    pile.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();next()}},{signal:ac.signal});
  }

  /* ================= CO ROBIMY: karuzele z rodzajami + blysk przy zmianie ================= */
  function initCarousel(media,ac){
    var track=media.querySelector('.vo-track');if(!track)return;
    var slides=[].slice.call(track.children),n=slides.length;
    var cnt=media.querySelector('[data-cnt]'),types=media.parentNode.querySelector('[data-types]');
    var pad=function(x){return (x<10?'0':'')+x};
    var seen=[],chips=[];
    if(types){types.innerHTML='';slides.forEach(function(s,i){var t=s.getAttribute('data-type');if(t&&seen.indexOf(t)<0){seen.push(t);var b=document.createElement('button');b.type='button';b.textContent=t;b.setAttribute('aria-pressed','false');b.addEventListener('click',function(){go(i)});types.appendChild(b);chips.push({t:t,b:b})}})}
    var cur=-1;
    function idx(){return Math.round(track.scrollLeft/Math.max(1,track.clientWidth))}
    function set(i,flash){
      if(i===cur||!slides[i])return;cur=i;if(cnt)cnt.textContent=pad(i+1)+' / '+pad(n);
      var t=slides[i].getAttribute('data-type');chips.forEach(function(c){c.b.setAttribute('aria-pressed',c.t===t?'true':'false')});
      if(flash&&!reduce){media.classList.remove('is-fire');void media.offsetWidth;media.classList.add('is-fire')}
    }
    function go(i){if(!n)return;i=(i+n)%n;track.scrollTo({left:i*track.clientWidth,behavior:reduce?'auto':'smooth'})}
    media._voGo=go;
    var st=null;
    track.addEventListener('scroll',function(){clearTimeout(st);st=setTimeout(function(){set(idx(),true)},70)},{passive:true,signal:ac.signal});
    var pv=media.querySelector('[data-prev]'),nx=media.querySelector('[data-next]');
    if(pv)pv.addEventListener('click',function(){go(idx()-1)},{signal:ac.signal});
    if(nx)nx.addEventListener('click',function(){go(idx()+1)},{signal:ac.signal});
    track.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){e.preventDefault();go(idx()+1)}if(e.key==='ArrowLeft'){e.preventDefault();go(idx()-1)}},{signal:ac.signal});
    /* przeciaganie mysza (dotyk = natywne przesuwanie) */
    var down=false,sx=0,sl=0;
    track.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse'||e.button!==0)return;down=true;sx=e.clientX;sl=track.scrollLeft},{signal:ac.signal});
    window.addEventListener('pointermove',function(e){if(!down)return;var dx=e.clientX-sx;if(Math.abs(dx)>4)track.classList.add('is-drag');track.scrollLeft=sl-dx},{signal:ac.signal});
    window.addEventListener('pointerup',function(e){if(!down)return;down=false;if(track.classList.contains('is-drag')){track.classList.remove('is-drag');var dx=e.clientX-sx,i=Math.round(sl/track.clientWidth);if(dx<-40)i++;else if(dx>40)i--;go(i)}},{signal:ac.signal});
    set(0,false);
  }

  /* ================= ZAUFALI NAM — motion.dev "Scroll velocity: 3D planes", tylko przeciaganie =================
     raw     <- przesuniecie palca/myszy * 2.5 (bez kolka i bez przewijania strony)
     smooth  <- spring(raw){stiffness:100,damping:30,mass:.5}; velocity = d(smooth)/dt
     plane i <- r = wrap(-S/2,S/2, i*step + smooth); fala spring{300,20,.3} -> v/50*sin(2PI r/(S/2))*5; hover spring{400,25} -> -30
             transform = translate3d(r, r*-.35 + fala + hover, r*-1.2) rotateY(-50deg) */
  function initPlanes(sec,ac){
    var vp=sec.querySelector('.vo-vp'),box=sec.querySelector('.vo-planes'),dataEl=sec.querySelector('[data-vo-planes]');
    if(!vp||!box||!dataEl)return;
    var DATA=[];try{DATA=JSON.parse(dataEl.textContent)||[]}catch(e){}
    if(!DATA.length)return;
    var PLANES=18;
    var CH='!@#$%^&*()_+-=[]{}|;:,.<>?/~░▒▓█▀▄■□▪▫●○◆◇◈◊※†‡';
    var nEl=sec.querySelector('[data-vo-count]');if(nEl)nEl.textContent='('+DATA.length+')';
    var W,STEP,S;
    function dims(){W=parseFloat(getComputedStyle(sec).getPropertyValue('--pw'))||320;STEP=W*.75;S=STEP*PLANES}
    dims();
    function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
    var P=[];
    box.innerHTML='';
    for(var i=0;i<PLANES;i++){
      var d=DATA[i%DATA.length],el=document.createElement('figure');el.className='vo-plane';
      var inner=d.img?'<div class="vo-im"><img src="'+esc(d.img)+'" alt="'+esc(d.name)+'" loading="lazy" draggable="false"></div>':'<div class="vo-ph"><div><b>'+esc(d.ph)+'</b><span>'+esc(d.sub)+'</span></div></div>';
      el.innerHTML=inner+'<div class="vo-ix">'+String(i%DATA.length).padStart(2,'0')+'</div><div class="vo-lab"><i></i><span></span></div>';
      box.appendChild(el);
      var o={el:el,name:d.name||'',span:el.querySelector('.vo-lab span'),wv:0,wvv:0,hv:0,hvv:0,hovT:0,scr:0};
      (function(o){if(hoverDevice){
        o.el.addEventListener('pointerenter',function(){o.hovT=-30;o.el.classList.add('is-hov');scramble(o);kick()},{signal:ac.signal});
        o.el.addEventListener('pointerleave',function(){o.hovT=0;o.el.classList.remove('is-hov');kick()},{signal:ac.signal});
      }})(o);
      P.push(o);
    }
    function scramble(o){var txt=o.name.toUpperCase(),start=performance.now();cancelAnimationFrame(o.scr);(function step(now){var k2=Math.floor((now-start)/50),out='';for(var k=0;k<txt.length;k++){out+=k<k2||txt[k]===' '?txt[k]:CH[Math.floor(Math.random()*CH.length)]}o.span.textContent=out;if(k2<txt.length)o.scr=requestAnimationFrame(step)})(start)}
    function wrapv(min,max,v){var r=max-min;return((((v-min)%r)+r)%r)+min}
    function spring(pos,vel,target,k,c,m,dt){var h=dt/4;for(var s=0;s<4;s++){var a=(-k*(pos-target)-c*vel)/m;vel+=a*h;pos+=vel*h}return[pos,vel]}
    var raw=0,sm=0,smv=0,raf=null,last=0,vis=false;
    function frame(now){
      if(ac.signal.aborted){raf=null;return}
      var dt=Math.min(.05,(now-last)/1000);last=now;
      var s=spring(sm,smv,raw,100,30,.5,dt);sm=s[0];smv=s[1];
      var moving=Math.abs(sm-raw)>.05||Math.abs(smv)>.5;
      for(var i=0;i<PLANES;i++){
        var o=P[i],r=wrapv(-S/2,S/2,i*STEP+sm),rn=r/(S/2);
        var target=reduce?0:Math.max(-240,Math.min(240,smv/50*Math.sin(rn*Math.PI*2)*5));
        var w=spring(o.wv,o.wvv,target,300,20,.3,dt);o.wv=w[0];o.wvv=w[1];
        var hh=spring(o.hv,o.hvv,o.hovT,400,25,1,dt);o.hv=hh[0];o.hvv=hh[1];
        if(Math.abs(o.wvv)>.5||Math.abs(o.wv)>.05||Math.abs(o.hv-o.hovT)>.05)moving=true;
        var y=r*-.35+o.wv+o.hv,z=r*-1.2;
        o.el.style.transform='translate3d('+r.toFixed(1)+'px,'+y.toFixed(1)+'px,'+z.toFixed(1)+'px) rotateY(-50deg)';
        o.el.style.visibility=z>1700?'hidden':'visible';
      }
      raf=(moving&&vis)?requestAnimationFrame(frame):null; /* w spoczynku zero pracy, nic nie jezdzi samo */
    }
    function kick(){if(!raf){last=performance.now();raf=requestAnimationFrame(frame)}}
    var down=false,px=0;
    vp.addEventListener('pointerdown',function(e){down=true;px=e.clientX;vp.classList.add('is-drag');try{vp.setPointerCapture(e.pointerId)}catch(_){}},{signal:ac.signal});
    vp.addEventListener('pointermove',function(e){if(!down)return;var dx=e.clientX-px;px=e.clientX;raw+=dx*2.5;kick()},{signal:ac.signal});
    function up(){down=false;vp.classList.remove('is-drag')}
    vp.addEventListener('pointerup',up,{signal:ac.signal});vp.addEventListener('pointercancel',up,{signal:ac.signal});
    vp.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){e.preventDefault();raw-=STEP;kick()}if(e.key==='ArrowLeft'){e.preventDefault();raw+=STEP;kick()}},{signal:ac.signal});
    window.addEventListener('resize',function(){dims();kick()},{signal:ac.signal});
    if('IntersectionObserver' in window){var io=new IntersectionObserver(function(en){vis=en[0].isIntersecting;if(vis)kick()});io.observe(sec);ac.signal.addEventListener('abort',function(){io.disconnect()})}else{vis=true}
    vis=true;last=performance.now();frame(last);vis=false;
  }

  /* ================= OBIEKTY 3D: wideo gra tylko, gdy jest widoczne ================= */
  function initVideo(v,ac){
    v.muted=true;
    function play(){var p=v.play();if(p&&p.catch)p.catch(function(){})}
    if(reduce){v.setAttribute('controls','');return}
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(en){if(en[0].isIntersecting){if(v.preload==='none')v.preload='auto';play()}else{v.pause()}},{rootMargin:'200px 0px'});
      io.observe(v);ac.signal.addEventListener('abort',function(){io.disconnect()});
    }else{v.preload='auto';play()}
  }

  /* ================= CTA: zegar Krakow ================= */
  function initClock(el,ac){
    function tick(){try{el.textContent=new Date().toLocaleTimeString('pl-PL',{timeZone:'Europe/Warsaw'})}catch(e){}}
    tick();var t=setInterval(tick,1000);ac.signal.addEventListener('abort',function(){clearInterval(t)});
  }

  /* ================= start / edytor motywu ================= */
  var MAP=[['[data-vo-gl]',initHero],['[data-vo-pile]',initPile],['[data-vo-car]',initCarousel],['[data-vo-video]',initVideo],['[data-vo-b2b]',initPlanes],['[data-vo-clock]',initClock]];
  function init(root){
    MAP.forEach(function(m){
      var list=[].slice.call(root.querySelectorAll(m[0]));
      if(root.matches&&root.matches(m[0]))list.push(root);
      list.forEach(function(el){
        if(el._voAc)return;
        var ac=new AbortController();el._voAc=ac;
        try{m[1](el,ac)}catch(e){if(window.console)console.warn('[vandal-onas]',e)}
      });
    });
  }
  function destroy(root){
    MAP.forEach(function(m){[].slice.call(root.querySelectorAll(m[0])).forEach(function(el){if(el._voAc){el._voAc.abort();el._voAc=null}})});
  }
  window.VandalOnas={init:init,destroy:destroy};
  function boot(){init(document)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
  document.addEventListener('shopify:section:unload',function(e){destroy(e.target)});
  document.addEventListener('shopify:block:select',function(e){
    var el=e.target,media=el&&el.closest&&el.closest('[data-vo-car]');
    if(media&&media._voGo){var i=[].indexOf.call(el.parentNode.children,el);if(i>-1)media._voGo(i)}
  });
})();
